export default "__VITE_ASSET__3de8c3a1__"